<!-- {{ filter }} - {{ filterId }} -->
<div class="faq" (clickOutside)="closeAllFaq()">
  <div *ngIf="categoryId != -1" class="faq__title">
    Discuss
    <span class="see-all-btn" (click)="openCommunityQuestionsModal()" id="discuss-btn">
      See All ({{ countForumMap || 0 }})
    </span>
    @if(viewOpenModelAddQuestion){
    <div class="faq-btn" (click)="openAskQuestionsModal()"><i class="fa-solid fa-plus"></i></div>
    }
  </div>

  <!-- -1 is hide faq title used for product details-->
  <ng-container *ngFor="let faq of additionalFAQS">
    <div *ngIf="faq.question && faq.answer" (click)="faq.dontShow = !!!faq.dontShow">
      <div class="arrow-border" [style.background-color]="backgroundColor" [style.background-color]="backgroundColor">
        {{ faq.question }}
        <h3 class="d-none">{{ faq.question }}</h3>
      </div>
      <div class="answer-block" [class.show]="faq.dontShow" [innerHTML]="faq.answer"></div>
      <h4 class="d-none">{{ faq.answer }}</h4>
    </div>
  </ng-container>
  <ng-container *ngIf="catFaqExist">
    <!-- Question One -->
    <div *ngIf="faqInfos.questionOne && faqInfos.answerOne" (click)="showFAQ(0)">
      <div class="arrow-border" [style.background-color]="backgroundColor">
        {{ faqInfos.questionOne }}
        <h3 class="d-none">{{ faqInfos.questionOne }}</h3>
      </div>
      <div class="answer-block" [class.show]="visibleFAQ[0]">
        <div [innerHTML]="faqInfos.answerOne"></div>
        <h4 class="d-none">{{ faqInfos.answerOne }}</h4>
        <div style="margin-top: 1rem; width: 50%" *ngIf="faqProducts[0]">
          <common-product-card-view [list]="faqProducts[0]"></common-product-card-view>
        </div>
      </div>
    </div>

    <!-- Question Two -->
    <div *ngIf="faqInfos.questionTwo && faqInfos.answerTwo" (click)="showFAQ(1)">
      <div class="arrow-border" [style.background-color]="backgroundColor">
        {{ faqInfos.questionTwo }}
        <h3 class="d-none">{{ faqInfos.questionTwo }}</h3>
      </div>
      <div class="answer-block" [class.show]="visibleFAQ[1]">
        <div [innerHTML]="faqInfos.answerTwo"></div>
        <h4 class="d-none">{{ faqInfos.answerTwo }}</h4>
        <div style="margin-top: 1rem; width: 50%" *ngIf="faqProducts[1]">
          <common-product-card-view [list]="faqProducts[1]"></common-product-card-view>
        </div>
      </div>
    </div>

    <!-- Question Three -->
    <div *ngIf="faqInfos.questionThree && faqInfos.answerThree" (click)="showFAQ(2)">
      <div class="arrow-border" [style.background-color]="backgroundColor">
        {{ faqInfos.questionThree }}
        <h3 class="d-none">{{ faqInfos.questionThree }}</h3>
      </div>
      <div class="answer-block" [class.show]="visibleFAQ[2]">
        <div [innerHTML]="faqInfos.answerThree"></div>
        <h4 class="d-none">{{ faqInfos.answerThree }}</h4>
        <div style="margin-top: 1rem; width: 50%" *ngIf="faqProducts[2]">
          <common-product-card-view [list]="faqProducts[2]"></common-product-card-view>
        </div>
      </div>
    </div>

    <!-- Question Four -->
    <div *ngIf="faqInfos.questionFour && faqInfos.answerFour" (click)="showFAQ(3)">
      <div class="arrow-border" [style.background-color]="backgroundColor">
        {{ faqInfos.questionFour }}
        <h3 class="d-none">{{ faqInfos.questionFour }}</h3>
      </div>
      <div class="answer-block" [class.show]="visibleFAQ[3]">
        <div [innerHTML]="faqInfos.answerFour"></div>
        <h4 class="d-none">{{ faqInfos.answerFour }}</h4>
        <div style="margin-top: 1rem; width: 50%" *ngIf="faqProducts[3]">
          <common-product-card-view [list]="faqProducts[3]"></common-product-card-view>
        </div>
      </div>
    </div>

    <!-- Question Five -->
    <div *ngIf="faqInfos.questionFive && faqInfos.answerFive" (click)="showFAQ(4)">
      <div class="arrow-border" [style.background-color]="backgroundColor">
        {{ faqInfos.questionFive }}
        <h3 class="d-none">{{ faqInfos.questionFive }}</h3>
      </div>
      <div class="answer-block" [class.show]="visibleFAQ[4]">
        <div [innerHTML]="faqInfos.answerFive"></div>
        <h4 class="d-none">{{ faqInfos.answerFive }}</h4>
        <div style="margin-top: 1rem; width: 50%" *ngIf="faqProducts[4]">
          <common-product-card-view [list]="faqProducts[4]"></common-product-card-view>
        </div>
      </div>
    </div>
  </ng-container>

</div>

<ng-template #askQuestionAboutCategory>
  <div class="ask-question">
    @if(viewOpenModelAddQuestion){
    <p class="title mb-3">Ask Question</p>
    }
    <div [class.viewOpenModelAddQuestion]="px-3">
      <textarea rows="6" placeholder="Write your question about products in this category" [(ngModel)]="askQuestionText"
        class="form-control"></textarea>
    </div>

    <!-- Image Upload Section -->
    <div class="image-upload-section">
      <div class="image-upload-area" (click)="fileInput.click()" [class.has-image]="selectedImage">
        <input #fileInput type="file" accept="image/*" (change)="onImageSelected($event)" class="d-none">
        <div class="upload-content" *ngIf="!selectedImage">
          <i class="fa-solid fa-cloud-upload-alt"></i>
          <span>Upload Image (Optional)</span>
        </div>
        <div class="image-preview" *ngIf="selectedImage">
          <img [src]="selectedImage" alt="Preview">
          <button type="button" class="remove-image" (click)="removeImage($event)">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
      </div>
    </div>

    <button class="my-2 btn btn-outline-primary" (click)="addQuestionToForumMap()">
      <i class="fa-solid fa-plus me-2"></i>Add Question
    </button>
  </div>
</ng-template>

<ng-template #answerQuestion>
  <div class="ask-question p-4">
    <p class="title mb-3">Post answer to questions "{{ answeringQuestion?.text }}"</p>
    <div style="width: 80%">
      <textarea rows="9" placeholder="Write your answer to  the selected question in this category"
        [(ngModel)]="answerQuestionText" class="form-control"></textarea>
    </div>

    <button class="mt-3 btn btn-outline-primary" (click)="addAnswerQuestion()">Answer Question</button>
  </div>
</ng-template>